import Vue from 'vue';
import Vuex from 'vuex';

import stocks from './modules/stocks';
import portfolio from './modules/portfolio';

import dashboard from './modules/dashboard';
import authentication from './modules/authentication';
import communication from './modules/communication';

import MDI from './teams/MDI';

// import * as actions from './actions';

import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuState: '',
    teams: [
      {humanName: 'None', databaseName: 'myrundash'},
      {humanName: 'Marathon Dynamics', databaseName: 'MDI'},
      {humanName: 'Just Keep Running', databaseName: 'JKR'},
      {humanName: 'Ryerson University', databaseName: 'Ryerson'},
      {humanName: 'Team Demo', databaseName: 'Demo'},
      // 'myrundash',
    ],
    winterRaces: [
      {name: 'Robbie Burns 8K', link: 'http://www.burlingtonrunners.com/races/robbie-burns-road-race/', date: 'Mid January'},
      {name: 'Chilly Half Marathon', link: 'http://www.chillyhalfmarathon.ca/site-chilly/Chilly_Half.html', date: 'Early March'},
    ],
    springRaces: [
      {name: 'Dynamo Race 5K', link: '', date: 'TBD'},
      {name: 'Dynamo Race 10K', link: '', date: 'TBD'},
      {name: 'Dynamo Race Half', link: '', date: 'TBD'},
      {name: 'Around The Bay 30K', link: 'https://bayrace.com/', date: 'End of March'},
      {name: 'Around The Bay Relay', link: 'https://bayrace.com/', date: 'End of March'},
      {name: 'Spring Run Off 8K', link: 'https://canadarunningseries.com/race-roster-spring-run-off/', date: 'Early April'},
      {name: 'Mt. Charleston Marathon', link: 'https://www.runrevel.com/rmc', date: 'Early April'},
      {name: 'Paris Marathon', link: 'https://www.schneiderelectricparismarathon.com/en/', date: 'Early April'},
      {name: 'London Marathon', link: 'https://www.virginmoneylondonmarathon.com/en-gb/', date: 'Late April'},
      {name: 'Boston Marathon', link: 'https://www.baa.org/', date: 'Late April'},
      {name: 'Missisauga Marathon', link: 'https://www.mississaugamarathon.com/', date: 'Early May'},
      {name: 'Missisauga Half', link: 'https://www.mississaugamarathon.com/', date: 'Early May'},
      {name: 'Toronto Marathon (Spring)', link: 'http://www.torontomarathon.com/', date: 'Early May'},
      {name: 'Toronto Half Mara (Spring)', link: 'http://www.torontomarathon.com/', date: 'Early May'},
      {name: 'Sporting Life 10K', link: 'https://sportinglife10k.ca/toronto/', date: 'Early May'},
    ],
    summerRaces: [
      {name: 'Toronto Womens Half Mara', link: 'http://towomensruns.com/events/half-marathon-5k/', date: 'Late May'},
      {name: 'Ottawa Marathon', link: 'https://www.runottawa.ca/', date: 'Late May'},
      {name: 'Ottawa Half', link: 'https://www.runottawa.ca/', date: 'Late May'},
      {name: 'Lulu Lemon Toronto 10K', link: 'https://canadarunningseries.com/toronto-10k/', date: 'Mid June'},
      {name: 'Beaches 10K', link: 'http://www.beachesjazzrun.com/', date: 'Late July'},
      {name: 'Beaches Half Marathon', link: 'http://www.beachesjazzrun.com/', date: 'Late July'},
      {name: 'Shakespeare 15K', link: 'http://www.shakespearerunsthenight.com/', date: 'Mid August'},
      {name: 'Shakespeare 30K', link: 'http://www.shakespearerunsthenight.com/', date: 'Mid August'},
      {name: 'Erie Marathon', link: 'https://eriemarathon.org/', date: 'Mid September'},
      {name: 'Ottawa Army Half Mara', link: 'https://armyrun.ca/', date: 'Mid September'},
    ],
    fallRaces: [
      {name: 'Berlin Marathon', link: 'https://www.bmw-berlin-marathon.com/en/', date: 'Late September'},
      {name: 'Chicago Marathon', link: 'https://support.researchautism.org/ChicagoMarathon', date: 'Early October'},
      {name: 'Waterfront Marathon', link: 'http://www.torontowaterfrontmarathon.com/', date: 'Mid October'},
      {name: 'Waterfront Half Mara', link: 'http://www.torontowaterfrontmarathon.com/', date: 'Mid October'},
      {name: 'Niagara Marathon', link: 'https://niagarafallsmarathon.com/', date: 'Mid October'},
      {name: 'Niagara Half Mara', link: 'https://niagarafallsmarathon.com/', date: 'Mid October'},
      {name: 'Marine Corps Marathon', link: 'https://www.taps.org/teamtaps/2019/mcm', date: 'Late October'},
      {name: 'New York Marathon', link: 'https://www.nyrr.org/tcsnycmarathon', date: 'Early November'},
      {name: 'Hamilton Marathon', link: 'http://www.hamiltonmarathon.ca/', date: 'Early November'},
      {name: 'Hamilton Half Marathon', link: 'http://www.hamiltonmarathon.ca/', date: 'Early November'},
      {name: 'Philadelphia Marathon', link: 'https://www.philadelphiamarathon.com/', date: 'Late November'},
      {name: 'Erie Marathon', link: 'https://www.runguides.com/event/11394/erie-marathon', date: ''},
      {name: 'Army Half', link: 'https://armyrun.ca/', date: 'Late November'},
      // 'Erie Marathon', 'Ottawa Army Half Mara', 'Berlin Marathon', 'Chicago Marathon', 'Waterfront Marathon', 'Waterfront Half Mara',
      // 'Niagara Marathon', 'Niagara Half Mara', 'Marine Corps Marathon', 'New York Marathon', 'Hamilton Marathon',
      // 'Hamilton Half Marathon', 'Philadelphia Marathon',
    ],
    xtrainingActivities: [
      'Cycling', 'Spinning', 'Elliptical', 'Water Running', 'Swimming', 'Rowing',
    ],
    injuries: [
      'Achilles Strain', 'Achilles Tear',
      'Bursitis',
      'Calf Muscle Strain', 'Calf Muscle Tear',
      'Glute Injury (max)', 'Glute Injury (med)', 'Glute Injury (min)',
      'Hamstring Strain', 'Hamstring Tear',
      'Hip Flexor Strain',
      'Iliotibial Band (ITB) Syndrome',
      'Low Back Pain',
      'Meniscus',
      'Patellar Tendonitis',
      'Posterior Tibial Tendonitis',
      'Quadriceps Strain', 'Quadriceps Tear',
      'Sciatica',
      'Shin Splints',
      'Stress Fracture (Femur)', 'Stress Fracture (Foot)', 'Stress Fracture (Pelvis)', 'Stress Fracture (Shin)',
      'TFL Pain',
    ],
    hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
    minuteOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
                    '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40',
                    '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
  },
  mutations: {
    storeMenuState (state, menuState) {
      state.menuState = menuState
    }
  },
  actions: {
    setMenuState ({commit}, menuState) {
      commit(storeMenuState, menuState)
    },

    convertTimeToSeconds ({commit}, time) {
      console.log('Converting time to seconds')
      console.log(time.hours)
      return time.hours * 2
    },
  },
  getters: {
    menuState (state) {
      return state.menuState
    },
    teams (state) {
      return state.teams
    },
    winterRaces (state) {
      return state.winterRaces
    },
    springRaces (state) {
      return state.springRaces
    },
    summerRaces (state) {
      return state.summerRaces
    },
    fallRaces (state) {
      return state.fallRaces
    },
    xtrainingActivities (state) {
      return state.xtrainingActivities
    },
    injuries (state) {
      return state.injuries
    },
    hourOptions (state) {
      return state.hourOptions
    },
    minuteOptions (state) {
      return state.minuteOptions
    },
  },
  // actions,
  modules: {
    stocks,
    portfolio,

    authentication,
    dashboard,
    communication,

    MDI,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js